<template>
  <div v-if="data.dataScheduleShipment.length" class="cardresult">
    <div class="cardheader">
      <div>
        <p class="text--blue1">
          Week {{ data.cutOffFormattedToWeeks }} -
          {{ data.dataScheduleShipment[0].year }}
        </p>
        <p>
          <span class="text--blue3">Transit time:</span>
          <span class="text--blue2">
            {{ countHighestLowestTransitTime(data.dataScheduleShipment) }} days
          </span>
        </p>
      </div>
      <div class="d-flex">
        <p
          v-if="data.dataScheduleShipment.length === 1"
          class="text--blue2 mr-5"
        >
          {{ data.dataScheduleShipment.length }} Result
        </p>
        <p v-else class="text--blue2 mr-5">
          {{ data.dataScheduleShipment.length }} Results
        </p>
        <div v-b-toggle="`collapse-weekscard-${data.cutOffFormattedToWeeks}`">
          <img
            src="@/assets/image/icon/icon-dropdown-gray.svg"
            class="icondropdown toggle when-opened"
            alt="dropdown"
          />
        </div>
      </div>
    </div>
    <b-collapse
      :id="`collapse-weekscard-${data.cutOffFormattedToWeeks}`"
      class="mt-3"
    >
      <div
        v-for="(item, idx) in data.dataScheduleShipment"
        :key="idx"
        class="cardshipment mt-3"
      >
        <div class="d-flex align-items-center mb-3">
          <div v-if="item.idShippingLine" class="circleicon px-2">
            <img
              :src="
                `https://www.searates.com/design/images/freight/sealine_cort/${item.idShippingLine}.jpg`
              "
              :alt="'logo-searates-' + item.idShippingLine"
              style="width: 40px; height: 40px; border-radius: 99px"
            />
          </div>
          <img
            v-else
            src="@/assets/image/icon/icon-sealine-default.svg"
            :alt="'logo-searates-' + 'default-' + idx"
            style="width: 58px; height: 58px; border-radius: 99px"
          />
          <p class="text--blue1">{{ item.shippingLine }}</p>
        </div>
        <div class="pt-3 pr-5 bordertop">
          <div class="d-flex justify-content-between position-relative">
            <div
              v-b-toggle="
                `collapse-weekscard-${data.cutOffFormattedToWeeks}-${idx}`
              "
              class="position-absolute"
              style="right: -2.25rem"
            >
              <img
                src="@/assets/image/icon/icon-dropdown-gray.svg"
                class="icondropdown toggle when-opened"
                alt="dropdown"
              />
            </div>
            <div class="text-left">
              <p class="text--blue1">
                {{ findPortData("departure", item.transShipments, "date") }}
              </p>
              <p class="text--blue3">
                {{ findPortData("departure", item.transShipments, "name") }},
                {{
                  findPortData(
                    "departure",
                    item.transShipments,
                    "unloCodeCountry"
                  )
                }}
              </p>
            </div>
            <div>
              <p class="text--blue1">{{ item.transitTime }} days</p>
            </div>
            <div class="text-right">
              <p class="text--blue1">
                {{ findPortData("arrival", item.transShipments, "date") }}
              </p>
              <p class="text--blue3">
                {{ findPortData("arrival", item.transShipments, "name") }},
                {{
                  findPortData(
                    "arrival",
                    item.transShipments,
                    "unloCodeCountry"
                  )
                }}
              </p>
            </div>
          </div>
          <div class="mt-5 position-relative">
            <hr class="horizontalline-blue" />
            <div
              v-if="item.transShipments.length < 2"
              class="countrytracking-wrapper"
              style="top: -5px"
            >
              <div class="pointcountry">
                <div class="circleicon">
                  <span class="text--blue2 mr-5 countrydesc">{{
                    item.transShipments[0].departure.portUnloCode.slice(2, 5)
                  }}</span>
                </div>
              </div>
              <div class="pointcountry">
                <div class="circleicon">
                  <span class="text--blue2 mr-5 countrydesc">{{
                    item.transShipments[0].arrival.portUnloCode.slice(2, 5)
                  }}</span>
                </div>
              </div>
            </div>

            <div v-else class="countrytracking-wrapper" style="top: -5px">
              <div
                v-for="(test, idx) in [...item.transShipments, 'DUMMY-DATA']"
                :key="idx"
                class="pointcountry"
              >
                <div
                  v-if="
                    idx === [...item.transShipments, 'DUMMY-DATA'].length - 1
                  "
                  class="circleicon"
                >
                  <span class="text--blue2 mr-5 countrydesc">{{
                    item.transShipments[
                      [...item.transShipments, "DUMMY-DATA"].length - 2
                    ].arrival.portUnloCode.slice(2, 5)
                  }}</span>
                </div>
                <div v-else-if="idx % 2 === 0" class="circleicon">
                  <span class="text--blue2 mr-5 countrydesc">{{
                    item.transShipments[idx].departure.portUnloCode.slice(2, 5)
                  }}</span>
                </div>
                <div v-else-if="idx % 2 === 1" class="circleicon">
                  <span class="text--blue2 mr-5 countrydesc">{{
                    item.transShipments[idx].departure.portUnloCode.slice(2, 5)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <b-collapse
            :id="`collapse-weekscard-${data.cutOffFormattedToWeeks}-${idx}`"
          >
            <div class="tablehead text--blue2">
              <p>Route Details</p>
              <p v-if="item.transShipments.length < 2">Direct</p>
            </div>
            <div v-for="(item2, idx2) in item.transShipments" :key="idx2">
              <div class="tableitem">
                <p class="text--blue3">Vessel Name</p>
                <p class="text--black2">
                  {{ item2.vesselName ? item2.vesselName : "N/A" }}
                </p>
              </div>
              <div class="tableitem">
                <p class="text--blue3">Voyage</p>
                <p class="text--black2">
                  {{ item2.voyage ? item2.voyage : "N/A" }}
                </p>
              </div>
              <div class="tableitem">
                <p class="text--blue3">Service</p>
                <p class="text--black2">
                  {{ item2.service ? item2.service : "N/A" }}
                </p>
              </div>
              <div class="tableitem">
                <p class="text--blue3">
                  {{ item2.departure.portName }},
                  {{ item2.departure.portUnloCode.slice(2, 5) }}
                </p>
                <p class="text--black2">
                  {{ formatDateTimeShipSchedule(item2.departure.date) }}
                </p>
              </div>
              <div class="tableitem">
                <p class="text--blue3">
                  {{ item2.arrival.portName }},
                  {{ item2.arrival.portUnloCode.slice(2, 5) }}
                </p>
                <p class="text--black2">
                  {{ formatDateTimeShipSchedule(item2.arrival.date) }}
                </p>
              </div>
              <div
                v-if="
                  item.transShipments.length > 1 &&
                    idx2 !== item.transShipments.length - 1
                "
                class="tableitem"
              >
                <p class="text--blue2">Transshipment</p>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CardResult',
  data () {
    return {
      tempDataScheduleShipment: {
        portDeparture: {
          name: null,
          unloCode: null,
          date: null
        },
        portArrival: {
          name: null,
          unloCode: null,
          date: null
        }
      },
      routesShipment: []
    }
  },
  props: {
    data: Object
  },
  components: {},
  watch: {},
  computed: {},
  created () {},
  methods: {
    countHighestLowestTransitTime (arr) {
      let lowest = Number.POSITIVE_INFINITY
      let highest = Number.NEGATIVE_INFINITY
      let tmp
      for (let i = arr.length - 1; i >= 0; i--) {
        tmp = arr[i].transitTime
        if (tmp < lowest) lowest = tmp
        if (tmp > highest) highest = tmp
      }
      if (highest === lowest) return lowest
      return `${lowest}-${highest}`
    },
    findPortData (port, arr, att) {
      if (port === 'departure') {
        if (att === 'name') return arr[0].departure.portName
        if (att === 'unloCodeCountry') { return arr[0].departure.portUnloCode.slice(0, 2) }
        if (att === 'unloCodeCity') { return arr[0].departure.portUnloCode.slice(2, 5) }
        if (att === 'date') { return moment.unix(arr[0].departure.date).format('DD MMM, YYYY') }
      } else {
        if (att === 'name') return arr[arr.length - 1].arrival.portName
        if (att === 'unloCodeCountry') { return arr[arr.length - 1].arrival.portUnloCode.slice(0, 2) }
        if (att === 'unloCodeCity') { return arr[arr.length - 1].arrival.portUnloCode.slice(2, 5) }
        if (att === 'date') {
          return moment
            .unix(arr[arr.length - 1].arrival.date)
            .format('DD MMM, YYYY') 
        }
      }
    },
    formatDateTimeShipSchedule (param) {
      return moment.unix(param).format('DD MMM, YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/CardResult.vue